import { render, staticRenderFns } from "./AttendeesList.vue?vue&type=template&id=7f5181c2&scoped=true"
import script from "./AttendeesList.vue?vue&type=script&lang=js"
export * from "./AttendeesList.vue?vue&type=script&lang=js"
import style0 from "./AttendeesList.vue?vue&type=style&index=0&id=7f5181c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5181c2",
  null
  
)

export default component.exports